module.exports = __webpack_public_path__ + "media/sapa_archive/ask_kantro_300x250-eeea8f13.png";